import * as React from 'react';
import { useCurrentBreakPoint } from '@react-front/hooks';
import { useTheme } from 'telia-front-react';
import DisturbanceClient from '@disturbance/DisturbanceClient';
import DisturbanceEmployee from '@disturbance/DisturbanceEmployee';

import { inject, observer } from 'mobx-react';

import SsoStore from '@stores/SsoStore';

export interface DisturbanceProps {
  ssoStore?: SsoStore;
}

function Disturbance(props: DisturbanceProps): React.ReactElement {
  const { breakPoints } = useTheme();
  const currentBreak = useCurrentBreakPoint(breakPoints);
  const isMobile = ['xs', 'sm', 'md'].includes(currentBreak);
  const {
    ssoStore: { isDealer }
  } = props;

  if (isDealer) {
    return <DisturbanceEmployee isMobile={isMobile} />;
  }

  return <DisturbanceClient isMobile={isMobile} />;
}

export default inject('ssoStore')(observer(Disturbance));
